import React, {ChangeEvent, FC} from 'react';

import {Dropdown, Input} from '@optimaxdev/design-system';
import {ActionCreatorWithPayload} from '@reduxjs/toolkit';
import {connect} from 'react-redux';

import {
    changeField,
    setErrorsSuccessPage,
} from 'desktop/pages/success/store/actions/orderItems/orderItems';
import {DoctorDetailsAndUploadValidatedType} from 'desktop/pages/success/types/orderItemsTypes';
import {useGetLocation, DEFAULT_COUNTRY} from 'hooks/location/location';
import {FieldType, DoctorDetailsType} from 'types/successPage';

import s from './manualDrDetails.scss';

// ts-unused-exports:disable-next-line
export const INPUTS = [
    {
        label: 'Patient Name',
        name: 'patientName',
    },
    {
        label: 'Doctor or Clinic name',
        name: 'name',
    },

    {
        label: 'City',
        name: 'city',
    },
] as const;

export type PropsType = {
    orderItemId: string;
    doctorDetails: DoctorDetailsType;
    validatedItems?: DoctorDetailsType;
    onDoctorDetailsChange: ({target}: ChangeEvent<HTMLInputElement>) => void;
    changeSuccessPageFields: ActionCreatorWithPayload<FieldType, string>;
    setErrors: ActionCreatorWithPayload<DoctorDetailsAndUploadValidatedType, string>;
};

/**
 * This component render inputs for manual typing dr details when customer chooses fill online
 * @param {PropsType} props - props type
 * @returns {React.ReactElement} Rendered react component
 */
export const ManualDrDetails: FC<PropsType> = ({
    changeSuccessPageFields,
    doctorDetails,
    onDoctorDetailsChange,
    orderItemId,
    setErrors,
    validatedItems,
}) => {
    const {regions} = useGetLocation(DEFAULT_COUNTRY);

    const states = regions ? regions[DEFAULT_COUNTRY] : [];

    /**
     * change field sets region for doctor details in store
     * set clean errors for region input by order item id b/c customer fills the region
     * @param {React.ReactNode} value - value
     */
    const onRegionChange = (value: React.ReactNode) => {
        const regionCode = (value || '').toString();
        changeSuccessPageFields({
            doctorDetails: {
                ...doctorDetails,
                regionCode,
            },
            orderItemId,
        } as FieldType);
        setErrors({
            [orderItemId]: {
                ...validatedItems,
                regionCode: '',
            },
        } as DoctorDetailsAndUploadValidatedType);
    };

    return (
        <div>
            {INPUTS.map(({label, name: title}) => (
                <div className={s.input} key={title}>
                    <Input
                        ariaLabel={label}
                        isError={Boolean(validatedItems?.[title])}
                        label={label}
                        name={title}
                        onChange={onDoctorDetailsChange}
                        value={doctorDetails[title]}
                    />
                </div>
            ))}
            <div className={s.field}>
                <Dropdown
                    error={Boolean(validatedItems?.regionCode)}
                    label="State"
                    onClick={onRegionChange}
                    options={states}
                    isWithLabel
                />
            </div>
        </div>
    );
};

export const ManualDrDetailsConnected = connect(null, {
    changeSuccessPageFields: changeField,
    setErrors: setErrorsSuccessPage,
})(ManualDrDetails);
